<template>
  <div v-if="isVisible" class="modal-overlay" @click.self="closeModal">
    <div class="modal">
      <button class="close-button" @click="$emit('close')">×</button>
      <h4 class="modal-top-text">本体</h4>

      <!-- パーツセクション -->
      <p>形状</p>
      <ul>
        <li>
          <span class="label">モデル選択:</span>
          <span
            class="value"
            :class="{ 'red-text': isUnselected('modelChoice') }"
          >
            {{ selected.modelChoice || "未選択" }}
          </span>
        </li>
        <li>
          <span class="label">ポジション:</span>
          <span class="value" :class="{ 'red-text': isUnselected('position') }">
            {{ selected.position || "未選択" }}
          </span>
        </li>
        <li>
          <span class="label">型名:</span>
          <span class="value" :class="{ 'red-text': isUnselected('typeName') }">
            {{ selected.typeName || "未選択" }}
          </span>
        </li>
        <li>
          <span class="label">グラブの左右:</span>
          <span
            class="value"
            :class="{ 'red-text': isUnselected('gloveHand') }"
          >
            {{ selected.gloveHand || "未選択" }}
          </span>
        </li>
        <li>
          <span class="label">バックスタイル:</span>
          <span
            class="value"
            :class="{ 'red-text': isUnselected('backStyle') }"
          >
            {{ selected.backStyle || "未選択" }}
          </span>
        </li>
        <li
          v-if="
            selected.backStyle === 'ライナーバック'
          "
        >
          <span class="label">ラベルの位置:</span>
          <span
            class="value"
            :class="{ 'red-text': isUnselected('labelPosition') }"
          >
            {{ selected.labelPosition || "未選択" }}
          </span>
        </li>
        <li
        v-if="
          selected.backStyle !== 'ライナーバック'
        "       
        >
          <span class="label">ベルト型:</span>
          <span class="value" :class="{ 'red-text': isUnselected('beltType') }">
            {{ selected.beltType || "未選択" }}
          </span>
        </li>
        <li>
          <span class="label">サイズ調整:</span>
          <span
            class="value"
            :class="{ 'red-text': isUnselected('fingerSize') }"
          >
            {{ selected.fingerSize || "未選択" }}
          </span>
        </li>
        <li>
          <span class="label">背面ひも通し:</span>
          <span
            class="value"
            :class="{ 'red-text': isUnselected('backStrand') }"
          >
            {{ selected.backStrand || "未選択" }}
          </span>
        </li>
        <li>
          <span class="label">ハミダシ:</span>
          <span
            class="value"
            :class="{ 'red-text': isUnselected('hamidashiChoice') }"
          >
            {{ selected.hamidashiChoice || "未選択" }}
          </span>
        </li>
        <li>
          <span class="label">トジ部:</span>
          <span
            class="value"
            :class="{ 'red-text': isUnselected('lacePortion') }"
          >
            {{ selected.lacePortion || "未選択" }}
          </span>
        </li>
        <li>
          <span class="label">トジ部のヒモ通し:</span>
          <span
            class="value"
            :class="{ 'red-text': isUnselected('laceStrand') }"
          >
            {{ selected.laceStrand || "未選択" }}
          </span>
        </li>
        <li>
          <span class="label">ウェブ:</span>
          <span class="value" :class="{ 'red-text': isUnselected('web') }">
            {{ selected.web || "未選択" }}
          </span>
        </li>
        <li
        v-if="
            selected.backStyle !== 'ライナーバック'
          "
        >
          <span class="label">指カバー・指アテ:</span>
          <span class="value" :class="{ 'red-text': isUnselected('finger') }">
            {{ selected.finger || "未選択" }}
          </span>
        </li>
      </ul>

      <!-- カラーセクション -->
      <p>カラー</p>
      <ul>
        <!-- <li>
          <span class="label">本体カラー:</span>
          <span
            class="value"
            :class="{ 'red-text': isUnselected('mainColor') }"
          >
            {{ selected.mainColor || "未選択" }}
          </span>
        </li> -->


        <template v-if="selected.backStyle == 'レギュラー'">
          <li>
            <span class="label">親指 外側カラー:</span>
            <span class="value" :class="{ 'red-text': isUnselected('thumbOut') }">
              {{ selected.thumbOut || "未選択" }}
            </span>
          </li>
          <li>
            <span class="label">親指 内側カラー:</span>
            <span class="value" :class="{ 'red-text': isUnselected('thumbIn') }">
              {{ selected.thumbIn || "未選択" }}
            </span>
          </li>
          <li>
            <span class="label">人差し指 外側カラー:</span>
            <span
              class="value"
              :class="{ 'red-text': isUnselected('indexFingerOut') }"
            >
              {{ selected.indexFingerOut || "未選択" }}
            </span>
          </li>
          <li>
            <span class="label">人差し指 内側カラー:</span>
            <span
              class="value"
              :class="{ 'red-text': isUnselected('indexFingerIn') }"
            >
              {{ selected.indexFingerIn || "未選択" }}
            </span>
          </li>
          <li>
            <span class="label">中指 外側カラー:</span>
            <span
              class="value"
              :class="{ 'red-text': isUnselected('middleFingerOut') }"
            >
              {{ selected.middleFingerOut || "未選択" }}
            </span>
          </li>
          <li>
            <span class="label">中指 内側カラー:</span>
            <span
              class="value"
              :class="{ 'red-text': isUnselected('middleFingerIn') }"
            >
              {{ selected.middleFingerIn || "未選択" }}
            </span>
          </li>
          <li>
            <span class="label">薬指 外側カラー:</span>
            <span
              class="value"
              :class="{ 'red-text': isUnselected('thirdFingerOut') }"
            >
              {{ selected.thirdFingerOut || "未選択" }}
            </span>
          </li>
          <li>
            <span class="label">薬指 内側カラー:</span>
            <span
              class="value"
              :class="{ 'red-text': isUnselected('thirdFingerIn') }"
            >
              {{ selected.thirdFingerIn || "未選択" }}
            </span>
          </li>
          <li>
            <span class="label">小指 外側カラー:</span>
            <span
              class="value"
              :class="{ 'red-text': isUnselected('littleFingerOut') }"
            >
              {{ selected.littleFingerOut || "未選択" }}
            </span>
          </li>
          <li>
            <span class="label">小指 内側カラー:</span>
            <span
              class="value"
              :class="{ 'red-text': isUnselected('littleFingerIn') }"
            >
              {{ selected.littleFingerIn || "未選択" }}
            </span>
          </li>
      </template>

      <template v-if="selected.backStyle == '王冠'">
          <li>
            <span class="label">親指 外側カラー:</span>
            <span class="value" :class="{ 'red-text': isUnselected('thumbOut') }">
              {{ selected.thumbOut || "未選択" }}
            </span>
          </li>
          <li>
            <span class="label">親指 内側カラー:</span>
            <span class="value" :class="{ 'red-text': isUnselected('thumbIn') }">
              {{ selected.thumbIn || "未選択" }}
            </span>
          </li>
          <li>
            <span class="label">人差し指 内側カラー:</span>
            <span
              class="value"
              :class="{ 'red-text': isUnselected('indexFingerIn') }"
            >
              {{ selected.indexFingerIn || "未選択" }}
            </span>
          </li>
          <li>
            <span class="label">人差し指 外側・中指 内側カラー:</span>
            <span
              class="value"
              :class="{ 'red-text': isUnselected('indexAndMiddleFinger') }"
            >
              {{ selected.indexAndMiddleFinger || "未選択" }}
            </span>
          </li>
          <li>
            <span class="label">中指 外側・薬指 内側カラー:</span>
            <span
              class="value"
              :class="{ 'red-text': isUnselected('middleAndThirdFinger') }"
            >
              {{ selected.middleAndThirdFinger || "未選択" }}
            </span>
          </li>
          <li>
            <span class="label">薬指 外側・小指 内側カラー:</span>
            <span
              class="value"
              :class="{ 'red-text': isUnselected('thirdAndLittleFinger') }"
            >
              {{ selected.thirdAndLittleFinger || "未選択" }}
            </span>
          </li>
          <li>
            <span class="label">小指 外側カラー:</span>
            <span
              class="value"
              :class="{ 'red-text': isUnselected('littleFingerOut') }"
            >
              {{ selected.littleFingerOut || "未選択" }}
            </span>
          </li>
      </template>

      <template v-if="selected.backStyle == 'ライナーバック'">
          <li>
            <span class="label">親指 外側カラー:</span>
            <span class="value" :class="{ 'red-text': isUnselected('thumbOut') }">
              {{ selected.thumbOut || "未選択" }}
            </span>
          </li>
          <li>
            <span class="label">親指 内側・人差し指・中指 内側側カラー:</span>
            <span class="value" :class="{ 'red-text': isUnselected('thumbIndexAndMiddleFinger') }">
              {{ selected.thumbIndexAndMiddleFinger || "未選択" }}
            </span>
          </li>
          <li>
            <span class="label">中指 外側・薬指 内側カラー:</span>
            <span class="value" :class="{ 'red-text': isUnselected('middleAndThirdFinger') }">
              {{ selected.middleAndThirdFinger || "未選択" }}
            </span>
          </li>
          <li>
            <span class="label">薬指 外側・小指 内側カラー:</span>
            <span
              class="value"
              :class="{ 'red-text': isUnselected('thirdAndLittleFinger') }"
            >
              {{ selected.thirdAndLittleFinger || "未選択" }}
            </span>
          </li>
          <li>
            <span class="label">小指 外側カラー:</span>
            <span
              class="value"
              :class="{ 'red-text': isUnselected('littleFingerOut') }"
            >
              {{ selected.littleFingerOut || "未選択" }}
            </span>
          </li>
      </template>

        <li v-if="!['親指一体', 'Tベルト'].includes(selected.beltType)">
          <span class="label">バンド:</span>
          <span
            class="value"
            :class="{ 'red-text': isUnselected('bandColor') }"
          >
            {{ selected.bandColor || "未選択" }}
          </span>
        </li>
        <li>
          <span class="label">捕球面:</span>
          <span
            class="value"
            :class="{ 'red-text': isUnselected('catchColor') }"
          >
            {{ selected.catchColor || "未選択" }}
          </span>
        </li>
        <li>
          <span class="label">親指掛け:</span>
          <span
            class="value"
            :class="{ 'red-text': isUnselected('thumbHanger') }"
          >
            {{ selected.thumbHanger || "未選択" }}
          </span>
        </li>
        <li>
          <span class="label">小指掛け:</span>
          <span
            class="value"
            :class="{ 'red-text': isUnselected('littleFingerHanger') }"
          >
            {{ selected.littleFingerHanger || "未選択" }}
          </span>
        </li>
        <li>
          <span class="label">ヘリ革:</span>
          <span
            class="value"
            :class="{ 'red-text': isUnselected('hemLeather') }"
          >
            {{ selected.hemLeather || "未選択" }}
          </span>
        </li>
        <li>
          <span class="label">ウェブ背面側・タテ棒:</span>
          <span class="value" :class="{ 'red-text': isUnselected('webBack') }">
            {{ selected.webBack || "未選択" }}
          </span>
        </li>
        <li>
          <span class="label">ウェブ捕球面側・ヨコ棒:</span>
          <span class="value" :class="{ 'red-text': isUnselected('webCatch') }">
            {{ selected.webCatch || "未選択" }}
          </span>
        </li>
        <li v-if="['W-23', 'W-27', 'W-28', 'W-T5', 'W-T6', 'W-T8', 'W-T12'].includes(selected.web)">
          <span class="label">ウェブエッジ・その他:</span>
          <span class="value" :class="{ 'red-text': isUnselected('webEdge') }">
            {{ selected.webEdge || "未選択" }}
          </span>
        </li>
        <li>
          <span class="label">平裏:</span>
          <span class="value" :class="{ 'red-text': isUnselected('hiraura') }">
            {{ selected.hiraura || "未選択" }}
          </span>
        </li>
        <li
          v-if="
              selected.beltType === 'Tベルト'
            "
        >
          <span class="label">トレジャーベルト:</span>
          <span
            class="value"
            :class="{ 'red-text': isUnselected('treasureBelt') }"
          >
            {{ selected.treasureBelt || "未選択" }}
          </span>
        </li>
        <li
          v-if="
              selected.backStyle === 'ライナーバック'
            "
        >
          <span class="label">ライナーバックベルト:</span>
          <span
            class="value"
            :class="{ 'red-text': isUnselected('linerBackBeltColor') }"
          >
            {{ selected.linerBackBeltColor || "未選択" }}
          </span>
        </li>
        <li v-if="selected.finger !== 'なし' && selected.backStyle !== 'ライナーバック'">
          <span class="label">指カバー・指あて:</span>
          <span
            class="value"
            :class="{ 'red-text': isUnselected('fingerCoverColor') }"
          >
            {{ selected.fingerCoverColor || "未選択" }}
          </span>
        </li>
        <li v-if="selected.hamidashiChoice === '切はみ'">
          <span class="label">{{ dynamicHamidashiLabel }}:</span>
          <span
            class="value"
            :class="{ 'red-text': isUnselected('additional') }"
          >
            {{ selected.additional || "未選択" }}
          </span>
        </li>
        <li v-if="selected.hamidashiChoice === '玉はみ'">
          <span class="label">{{ dynamicHamidashiLabel }}:</span>
          <span
            class="value"
            :class="{ 'red-text': isUnselected('additional') }"
          >
            {{ selected.additional || "未選択" }}
          </span>
        </li>
        <li>
          <span class="label">レース:</span>
          <span
            class="value"
            :class="{ 'red-text': isUnselected('laceColor') }"
          >
            {{ selected.laceColor || "未選択" }}
          </span>
        </li>
        <li>
          <span class="label">ステッチ:</span>
          <span
            class="value"
            :class="{ 'red-text': isUnselected('stitchColor') }"
          >
            {{ selected.stitchColor || "未選択" }}
          </span>
        </li>
        <li>
          <span class="label">トレジャーラベル:</span>
          <span
            class="value"
            :class="{ 'red-text': isUnselected('treasureLabelChoice') }"
          >
            {{ selected.treasureLabelChoice || "未選択" }}
          </span>
        </li>
        <li
          v-if="
            selected.treasureLabelChoice === 'オリジナル（+3,300円&納期+30日）'
          "
        >
          <span class="label">メインカラー:</span>
          <span
            class="value"
            :class="{ 'red-text': isUnselected('optionMainColor') }"
          >
            {{ selected.optionMainColor || "未選択" }}
          </span>
        </li>
        <li
          v-if="
            selected.treasureLabelChoice === 'オリジナル（+3,300円&納期+30日）'
          "
        >
          <span class="label">カゲカラー:</span>
          <span
            class="value"
            :class="{ 'red-text': isUnselected('optionShadowColor') }"
          >
            {{ selected.optionShadowColor || "未選択" }}
          </span>
        </li>
        <li
          v-if="
            selected.treasureLabelChoice === 'オリジナル（+3,300円&納期+30日）'
          "
        >
          <span class="label">台カラー:</span>
          <span
            class="value"
            :class="{ 'red-text': isUnselected('optionStandColor') }"
          >
            {{ selected.optionStandColor || "未選択" }}
          </span>
        </li>
      </ul>

      <div class="emblem">
        <p>刺繍設定一覧</p>
        <ul v-if="savedSelections.length" class="selection-list">
          <li
            v-for="(selection, index) in savedSelections"
            :key="index"
            class="selection-item"
          >
            <!-- 刺繍設定タイトル -->
            <div class="selection-title">刺繍設定 {{ index + 1 }}</div>

            <!-- 詳細情報 -->
            <ul class="selection-details">
              <li class="selection-detail">
                <span class="label">刺繍位置:</span>
                <span class="value">{{
                  selection.embroideryPosition || "未選択"
                }}</span>
              </li>
              <li class="selection-detail">
                <span class="label">書体:</span>
                <span class="value">{{ selection.font || "未選択" }}</span>
              </li>
              <li class="selection-detail">
                <span class="label">書体カラー:</span>
                <span class="value">{{ selection.fontColor || "未選択" }}</span>
              </li>
              <li class="selection-detail">
                <span class="label">カゲ・フチ:</span>
                <span class="value">{{
                  selection.shadowEdge || "未選択"
                }}</span>
              </li>
              <li
                v-if="selection.shadowEdge === 'カゲ'"
                class="selection-detail"
              >
                <span class="label">カゲカラー:</span>
                <span class="value">{{
                  selection.shadowColor || "未選択"
                }}</span>
              </li>
              <li
                v-if="selection.shadowEdge === 'フチ'"
                class="selection-detail"
              >
                <span class="label">フチカラー:</span>
                <span class="value">{{ selection.edgeColor || "未選択" }}</span>
              </li>
              <li class="selection-detail">
                <span class="label">刺繍内容:</span>
                <span class="value">{{
                  selection.embroideryContent || "未入力"
                }}</span>
              </li>
            </ul>
          </li>
        </ul>
        <p v-else>刺繍設定はありません。</p>
      </div>

      <div class="modal__bottom_fixed">
        <div class="modal-price">
          合計金額: {{ totalPrice.toLocaleString() }}円<br><span class="tax-free">
            (税抜{{
              Number((totalPrice / 1.1).toFixed(0)).toLocaleString()
            }}円)</span
          >
        </div>
        <!-- 遷移先を分岐 -->
        <div class="form-row form__btn_gap">
          <div class="col">
            <a
              href="/order-form"
              class="form-btn-block form-btn-secondary btn btn-block"
              @click.prevent="saveAndNavigate('/order-form')"
              >注文手続きへ進む</a
            >
          </div>
          <div class="col">
            <a
              href="/shop-order-form"
              class="form-btn-block form-btn-secondary btn btn-block"
              @click.prevent="saveAndNavigate('/shop-order-form')"
              >販売店で購入する方はこちら</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DetailModal",
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    totalPrice: {
      type: Number, // totalPrice は数値型
      required: true, // 必須プロパティ
    },
    selected: {
      type: Object,
      default: () => ({
        //パーツ
        modelChoice: "未選択",
        position: "未選択",
        typeName: "未選択",
        gloveHand: "未選択",
        backStyle: "未選択",
        labelPosition: "未選択",
        beltType: "未選択",
        fingerSize: "未選択",
        backStrand: "未選択",
        hamidashiChoice: "未選択",
        lacePortion: "未選択",
        laceStrand: "未選択",
        web: "未選択",
        finger: "未選択",

        //カラー
        mainColor: "未選択",
        thumbOut: "未選択",
        thumbIn: "未選択",
        indexFingerOut: "未選択",
        indexFingerIn: "未選択",
        middleFingerOut: "未選択",
        middleFingerIn: "未選択",
        thirdFingerOut: "未選択",
        thirdFingerIn: "未選択",
        littleFingerOut: "未選択",
        littleFingerIn: "未選択",
        bandColor: "未選択",
        catchColor: "未選択",
        thumbHanger: "未選択",
        littleFingerHanger: "未選択",
        hemLeather: "未選択",
        webBack: "未選択",
        webCatch: "未選択",
        webEdge: "未選択",
        hiraura: "未選択",
        treasureBelt: "未選択",
        linerBackBeltColor: "未選択",
        fingerCoverColor: "未選択",
        additional: "未選択", // ハミダシ追加選択の値
        laceColor: "未選択",
        stitchColor: "未選択",
        treasureLabelChoice: "未選択",
        optionMainColor: "未選択",
        optionShadowColor: "未選択",
        optionStandColor: "未選択",

        //刺繍
        embroideryPosition: "未選択",
        font: "未選択",
        fontColor: "未選択",
        shadowEdge: "未選択",
        shadowColor: "未選択",
        edgeColor: "未選択",
        embroideryContent: "未入力",
      }),
    },
    savedSelections: {
      type: Array,
      required: true, // 必須プロパティに設定
    },
  },

  mounted() {
    // デバッグ用: 受け取ったプロパティを確認
    console.log("受け取った selected:", this.selected);
    console.log(
      "is selected デフォルト値が使用されていますか？",
      this.selected === this.$options.props.selected.default()
    );
  },
  computed: {
    // 動的なラベル
    dynamicHamidashiLabel() {
      if (this.selected.hamidashiChoice === "切はみ") {
        return "ハミダシ:切はみカラー";
      } else if (this.selected.hamidashiChoice === "玉はみ") {
        return "ハミダシ:玉はみカラー";
      }
      return "ハミダシを選択してください";
    },
    isUnselected() {
      return (key) => !this.selected[key] || this.selected[key] === "未選択";
    },
    isUnselectedSelection() {
      return (selection, key) =>
        !selection[key] ||
        selection[key] === "未選択" ||
        selection[key] === "未入力";
    },
  },

  methods: {
    closeModal() {
      this.$emit("close");
    },

    saveAndNavigate(destination) {
      console.log("saveAndNavigate が呼び出されました！");
      console.log("selected の内容:", this.selected);

      const fieldLabels = {
        //パーツ
        modelChoice: "モデル選択",
        position: "ポジション",
        typeName: "型名",
        gloveHand: "グラブの左右",
        backStyle: "バックスタイル",
        beltType: "ベルト型",
        fingerSize: "サイズ調整",
        backStrand: "背面ひも通し",
        hamidashiChoice: "ハミダシ",
        lacePortion: "トジ部",
        laceStrand: "トジ部のヒモ通し",
        web: "ウェブ",
        finger: "指カバー・指アテ",
        mainColor: "本体カラー",
        thumbOut: "親指外側カラー",
        thumbIn: "親指内側カラー",
        indexFingerOut: "人差し指外側カラー",
        indexFingerIn: "人差し指内側カラー",
        middleFingerOut: "中指外側カラーー",
        middleFingerIn: "中指内側カラーー",
        thirdFingerOut: "薬指外側カラー",
        thirdFingerIn: "薬指内側カラー",
        littleFingerOut: "小指外側カラー",
        littleFingerIn: "小指内側カラー",
        bandColor: "バンド",
        catchColor: "捕球面",
        thumbHanger: "親指掛け",
        littleFingerHanger: "小指掛け",
        hemLeather: "ヘリ革",
        webBack: "ウェブ背面側・タテ棒",
        webCatch: "ウェブ捕球面・ヨコ側",
        webEdge: "ウェブエッジ・その他",
        hiraura: "平裏",
        treasureBelt: "トレジャーベルト",
        linerBackBeltColor: "ライナーバックベルト",
        fingerCoverColor: "指カバー・指アテ",

        additional: "切はみ、玉はみ",
        laceColor: "レース",
        stitchColor: "ステッチ",
        treasureLabelChoice: "トレジャーラベル",
        optionMainColor: "メインカラー",
        optionShadowColor: "カゲカラー",
        optionStandColor: "台カラー",

        //   //刺繍
        //   embroideryPosition: "未選択",
        //   font: "未選択",
        //   fontColor: "未選択",
        //   shadowEdge: "未選択",
        //   shadowColor: "未選択",
        //   edgeColor: "未選択",
        //   embroideryContent: "未入力",
      };

      // nullでも良い項目リスト
      const excludeKeys = [
        "embroideryPosition",
        "font",
        "fontColor",
        "shadowEdge",
        "shadowColor",
        "edgeColor",
        "embroideryContent",
      ]; // 他の完全に無視する項目

      // 条件付きでチェックを緩める項目
      const conditionalExcludes = {
        beltType: () => this.selected.backStyle === "ライナーバック",
        finger: () => this.selected.backStyle === "ライナーバック",
        optionMainColor: () =>
          this.selected.treasureLabelChoice !==
          "オリジナル（+3,300円&納期+30日）",
        optionShadowColor: () =>
          this.selected.treasureLabelChoice !==
          "オリジナル（+3,300円&納期+30日）",
        optionStandColor: () =>
          this.selected.treasureLabelChoice !==
          "オリジナル（+3,300円&納期+30日）",
        webEdge: () =>
          !['W-23', 'W-27', 'W-28', 'W-T5', 'W-T6', 'W-T8', 'W-T12'].includes(this.selected.web),
        bandColor: () =>
           ['親指一体', 'Tベルト'].includes(this.selected.beltType),  
      };

      this.missingFields = [];

      // 未選択項目を収集
      const unselectedItems = Object.entries(this.selected).filter(
        ([key, value]) => {
          // 完全に無視する項目
          if (excludeKeys.includes(key)) {
            return false;
          }

          // 条件付きで無視する項目
          if (key in conditionalExcludes && conditionalExcludes[key]()) {
            return false;
          }

          // null や未選択のチェック
          return (
            value === "未選択" ||
            value === "未入力" ||
            value === null ||
            value === ""
          );
        }
      );

      // 日本語ラベルに変換
      const unselectedLabels = unselectedItems.map(
        ([key]) => fieldLabels[key] || key // ラベルがない場合はそのままkeyを使用
      );

      // 刺繍設定を監視
      this.savedSelections.forEach((selection, index) => {
        const { shadowEdge, shadowColor, edgeColor } = selection;

        // カゲ・フチの選択に応じたチェック
        if (shadowEdge === "カゲ") {
          if (!shadowColor || shadowColor === "未選択") {
            unselectedItems.push(`刺繍設定 ${index + 1}: カゲカラーが未選択`);
          }
        } else if (shadowEdge === "フチ") {
          if (!edgeColor || edgeColor === "未選択") {
            unselectedItems.push(`刺繍設定 ${index + 1}: フチカラーが未選択`);
          }
        } else if (shadowEdge === "なし") {
          // 「なし」の場合、カラーの選択は不要
        } else {
          // shadowEdge が未選択または無効な値の場合
          if (shadowEdge === "未選択") {
            // カラーが選択されている場合エラー
            if (
              (shadowColor && shadowColor !== "未選択") ||
              (edgeColor && edgeColor !== "未選択")
            ) {
              unselectedItems.push(
                `刺繍設定 ${
                  index + 1
                }: カゲ・フチの選択が必要ですが、カラーが選択されています`
              );
            }
          }
        }

        // 他の必須項目 (例: embroideryPosition, font, fontColor) をチェック
        const requiredFields = [
          { key: "embroideryPosition", label: "刺繍位置" },
          { key: "font", label: "書体" },
          { key: "fontColor", label: "書体カラー" },
          { key: "embroideryContent", label: "刺繍内容" },
        ];
        requiredFields.forEach(({ key, label }) => {
          if (
            !selection[key] ||
            selection[key].trim() === "" ||
            selection[key] === "未選択"
          ) {
            unselectedItems.push(
              `刺繍設定 ${index + 1}: ${label} が未選択または未入力です`
            );
          }
        });
      });

      // DetailModal.vue の saveAndNavigate()内
      // ↓未入力のキーだけ抜き出して unselectedKeys という配列を作る
      const unselectedKeys = unselectedItems.map(([key]) => key);

      // 親に教える
      this.$emit("missing-fields-updated", unselectedKeys);

      // 未選択項目がある場合
      if (unselectedItems.length > 0) {
        // 未選択の項目をコンソールに出力
        console.error("未選択と判定された項目:", unselectedItems);
        alert("未選択の項目があります:\n" + unselectedLabels.join("\n"));
        return; // 処理を中断（ページ遷移しない）
      }

      // 未選択のチェック↑
      // ローカルストレージに選択内容を保存
      localStorage.setItem("selectedData", JSON.stringify(this.selected));
      localStorage.setItem("totalPrice", JSON.stringify(this.totalPrice));
      // 刺繍設定を localStorage に保存
      localStorage.setItem(
        "savedSelections",
        JSON.stringify(this.savedSelections)
      );
      // 指定されたURLに遷移
      this.$router.push(destination);
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0px;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 991000;
}

.modal {
  background: white;
  padding: 20px 20px 0px 20px;
  border-radius: 5px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1001;
  position: relative;
  display: block;
  color: black;
  max-height: 75%;
  width: 50%;
  top: -6%;
}

.close-button {
  position: sticky; /* 絶対位置を指定 */
  top: 0; /* モーダル内での上からの距離 */
  right: 0; /* モーダル内での右からの距離 */
  background: none;
  border: none;
  font-size: 40px;
  cursor: pointer;
  color: gray;
  font-weight: bold;
  text-align: right;
  width: 100%;
}
.modal-top-text {
  background-color: black;
  color: white;
  padding: 5px;
  font-size: 1.2rem;
}
.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form__btn_gap {
  gap: 5vw;
  padding: 1vw 0 1vw 0;
}

.form-btn-block {
  padding: 10px;
  font-size: 16px;
  border-radius: 25px;
}
.btn-block {
  display: block;
  width: 100%;
}

.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.form__main {
  max-width: 700px;
}
.modal__bottom_fixed {
  position: sticky;
  bottom: 0vw;
  left: 0;
  width: 100%;
  background-color: white;
  padding: 0px 0px;
}
@media (max-height: 400px) {
  .modal__bottom_fixed {
    position: static;
  }
}
.modal-price {
  color: #000000;
  text-align: right;
  font-weight: bold;
  font-size: x-large;
}
.tax-free {
  font-size: 1rem;
}

ul li {
  display: flex; /* フレックスボックスで整列 */
  justify-content: space-between; /* 左右にラベルと値を配置 */
  align-items: center; /* 縦方向を中央揃え */
  padding: 5px 10px;
  border-bottom: 1px solid #ddd;
}
/* ラベル部分 */
ul li .label {
  font-weight: bold; /* 太字 */
  flex-basis: 40%; /* ラベルの幅を指定 */
  text-align: left; /* 左寄せ */
  margin-left: 1rem;
}

/* 値部分 */
ul li .value {
  flex-basis: 60%; /* 値の幅を指定 */

  text-align: left; /* 左寄せに変更 */
}

@media (max-width: 1500px) {
  .modal {
    width: 50%;
    max-height: 90%;
    top: 0%;
    margin-left: auto;
    margin-right: auto;
  }
}
@media (max-width: 1200px) {
  .modal {
    width: 60%;
  }
}

@media (max-width: 1000px) {
  .modal {
    width: 70%;
    max-height: 55%;
  }
}

@media (max-width: 768px) {
  li {
    font-size: 0.7rem;
  }
  .modal__bottom_fixed {
    bottom: 0vw;
  }
  .modal {
    max-height: 54%;
    width: 86%;
    top: -19%;
  }
}

@media (max-width: 640px) {
  .form-btn-block {
    padding: 10px 0;
    font-size: 68%;
  }
  ul li .label {
    flex-basis: 55%; /* ラベルの幅を指定 */
  }

  ul li .value {
    flex-basis: 45%; /* 値の幅を指定 */
  }
}
@media (max-width: 400px) {
  .form-btn-block {
    font-size: 50%;
  }
}

@media (min-width: 769px) and (max-width: 1500px) {
  .modal-overlay {
    /* top: -71vw; */
    width: 100%;
    /* height: 500px; */
  }
}
@media (max-width: 768px) {
  .modal-overlay {
    top: 0px;
    height: 100%;
  }
}

@media (min-width: 769px) and (max-height: 700px) {
  .modal {
    max-height: 84%;
    top: -20%;
  }
}
/* リストアイテムのスタイル */
ul {
  list-style: none; /* リストマーカーを非表示にする */
  padding: 0; /* 不要なパディングを削除 */
  margin: 0; /* 不要なマージンを削除 */
}

ul li:nth-child(odd) {
  background-color: #f9f9f9; /* 奇数行の背景色 */
}

ul li:nth-child(even) {
  background-color: #ffffff; /* 偶数行の背景色 */
}

.selection-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.selection-item {
  margin-bottom: 20px;
  border: 3px solid #ddd;
  background-color: #f9f9f9; /* 背景色 */
}

.selection-title {
  background-color: #dcdcdc; /* タイトル背景色 */
  font-weight: bold;
  padding: 10px;
  text-align: left;
}

.selection-details {
  padding: 10px; /* 詳細情報の余白 */
  list-style: none;
}

.selection-detail {
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  border-bottom: 1px solid #ddd;
}

.label {
  font-weight: bold;
  text-align: left;
}

.value {
  text-align: left;
}
.emblem ul li {
  display: block;
}
.emblem ul li .value {
  flex-basis: 60%; /* 値の幅を指定 */
  text-align: left; /* 左寄せに変更 */
}

::-webkit-scrollbar-thumb {
  background: #7f7f7f;
  background-image: radial-gradient(circle, white 100%);
  background-size: cover;
  height: 30px;
  border-radius: 0px 5px 5px 0px;
}

/* ホバー時 */
::-webkit-scrollbar-thumb:hover {
  background: #f8f8f8;
  border-color: gray;
}

/* スクロールバーの背景 */
::-webkit-scrollbar-track {
  background: black;
  border-radius: 0px 5px 5px 0px;
}

/* .red-text {
  color: red;
  font-weight: bold;
} */
.value {
  text-align: left;
}

/* 未選択のテキストを赤くする */
/* .value:contains("未選択"),
.value:contains("未入力") {
  color: red;
} */
</style>
